import { ZfAccordion, ZfAccordionItem, ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent, PropsWithChildren } from 'react';

interface IMultiLanguageInputWrapperProps extends PropsWithChildren {
    collapsible?: boolean;
    expanded?: boolean;
    label?: string;
}

export const MultiLanguageInputWrapper: FunctionComponent<IMultiLanguageInputWrapperProps> = ({ collapsible, expanded, label, children }) =>
    collapsible ? (
        <ZfAccordion type="single">
            <ZfAccordionItem state={expanded ? 'active' : 'default'} showUnderline={true} size="medium" titleText={label}>
                <ZfStack direction="column" spacing="medium">
                    {children}
                </ZfStack>
            </ZfAccordionItem>
        </ZfAccordion>
    ) : (
        <ZfStack direction="column" spacing="small">
            {!!label && !collapsible ? (
                <ZfTypography variant="label-large" weight="bold">
                    {label}
                </ZfTypography>
            ) : null}
            {children}
        </ZfStack>
    );
